<!-- Table div -->
<!-- Displayed using [ngStyle] value of displayType -->
<mat-grid-list id="table" cols="1" rows="9" rowHeight="fit" [ngStyle]="{display: displayType}">

    <!-- Studies search dialog -->
    <mat-grid-tile id="searchTile" [rowspan]="1">
        <mat-form-field class="example-form-field" style="width:37vw">
            <mat-label>Search for Study</mat-label>
            <input matInput id="searchForStudy" type="text" [(ngModel)]="studyFilter" (ngModelChange)="filterStudyTable(studyFilter)">
            <button *ngIf="studyFilter" matSuffix mat-icon-button aria-label="Clear" (click)="studyFilter='';filterStudyTable(studyFilter)">
                <span aria-hidden="false" aria-label="clear search" role="presentation" class="esri-icon esri-icon-close-circled"></span>
            </button>
          </mat-form-field>
    </mat-grid-tile>
    
    <!-- Studies feature table -->
    <mat-grid-tile [rowspan]="4">
        <div id="studiesTableDiv"></div>
    </mat-grid-tile>

    <!-- Elevations feature table -->
    <mat-grid-tile [rowspan]="4">
        <div id="elevationsTableDiv"></div>
    </mat-grid-tile>

</mat-grid-list>